import { useSirWidget } from '@/hooks/useSirWidget';

export interface BetradarLmtWidgetProps {
  eventId: number;
  language?: string;
  className?: string;
}

const LMT_PLUS_OPTIONS = {
  layout: 'single',
  scoreboard: 'disable',
  tabsPosition: 'top',
  momentum: 'compact',
} as const;

export function BetradarLmtWidget({ eventId, language = 'en', className }: BetradarLmtWidgetProps) {
  const containerId = useSirWidget('match.lmtPlus', eventId, LMT_PLUS_OPTIONS, language);

  return <div id={containerId} data-container="livedetailswidget" className={className} />;
}
